import { RenderResult } from '@testing-library/react';
import { type ReactElement } from 'react';

import { render } from '@dynatrace/strato-components-testing/jest';

type CustomRender = RenderResult & { content: HTMLElement };

/**
 * Render helper that binds the editor content HTML element to the render
 * result.
 */
export const renderAndGetContentElement = (ui: ReactElement): CustomRender => {
  const rendered = render(ui);

  return {
    ...rendered,
    content: rendered.getByTestId('base-code-editor-content'),
  };
};
